<p class="laft-form--title">Procesos o investigaciones</p>

<form class="laft-form" [formGroup]="investigationForm">
  <section class="laft-form--group">
    <p class="laft-form--group-title">
      La empresa o alguno de sus representantes legales está o ha sido
      <span class="bold-700">investigado</span>, <span class="bold-700">procesado</span> o
      <span class="bold-700">condenado</span> por delitos como:
    </p>

    <div class="laft-form--investigation-list">
      <span class="laft-form--investigation-item">Lavado de activos</span>
      <span class="laft-form--investigation-item">Corrupción</span>
      <span class="laft-form--investigation-item">Terrorismo</span>
      <span class="laft-form--investigation-item">Nacrotráfico</span>
      <span class="laft-form--investigation-item">Extorsión</span>
      <span class="laft-form--investigation-item">Minería ilegal</span>
      <span class="laft-form--investigation-item">Delitos contra la administración pública</span>
      <span class="laft-form--investigation-item">Defraudación tributaria</span>
      <span class="laft-form--investigation-item">Conexos a criminalidad organizada</span>
    </div>

    <mat-radio-group class="laft-form--radio-button" formControlName="isInvestigated">
      <mat-radio-button [value]="false"><span class="laft-form-option">No</span></mat-radio-button>
      <mat-radio-button [value]="true"><span class="laft-form-option">Sí</span></mat-radio-button>
    </mat-radio-group>

    <div *ngIf="investigationForm.get('isInvestigated')?.value" class="laft-form--input-group">
      <div formArrayName="investigations">
        <div
          class="laft-form--investigation-entry u-mb-2"
          *ngFor="let investigation of investigations.controls; let i = index; trackBy: trackByIndex"
          [formGroupName]="i"
        >
          <div class="form-group-2 u-mb-1">
            <app-input
              class="laft-form--block-width"
              formControlName="prosecutorOffice"
              label="Fiscalía o juzgado"
            ></app-input>
            <app-input
              class="laft-form--block-width"
              formControlName="caseNumber"
              label="Nº Carpeta Fiscal / Expediente"
            ></app-input>
          </div>
          <div class="form-group-2">
            <app-select
              class="laft-form--block-width"
              formControlName="caseStatus"
              [options]="caseStatusOptions"
              valueField="value"
              textField="text"
              label="Estado del proceso / Resolución final"
            ></app-select>
            <app-input
              class="laft-form--block-width"
              formControlName="defendantName"
              label="Nombre del investigado, procesado o condenado"
            ></app-input>
          </div>
        </div>
      </div>

      <button type="button" class="laft-form--add-button" (click)="onAddInvestigation()">
        Añadir
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
            fill="#0256FF"
          />
        </svg>
      </button>
    </div>
  </section>

  <app-section-message
    text="La información que completes en este formulario será tomada como una declaración jurada. La usaremos para cumplir con nuestros procesos de validación (conocer a nuestros clientes) y para generar tu contrato con Finsmart."
    type="informative"
  ></app-section-message>

  <section class="laft-form--checkbox">
    <app-checkbox
      *ngIf="!isClient"
      content='<span>He leído y acepto el <a class="bold-600 blue" href="https://storage.googleapis.com/finsmart-websitefiles/legal/Contrato%20del%20inversionista%20v3.2.docx.pdf" target="_blank">Contrato de Inversionista</a></span>'
      formControlName="acceptsContract"
      errorMessage="Requerido"
    ></app-checkbox>
    <app-checkbox
      content='<span>Acepto que mis datos proporcionados en el formulario PLAFT puedan ser utilizados para fines comerciales, conforme a la política de privacidad vigente.</span>'
      formControlName="acceptsCommercialUse"
    ></app-checkbox>
  </section>

  <div class="laft-form--actions">
    <button class="laft-form--btn-submit" type="button" [disabled]="isSaving" (click)="onContinue()">
      {{ isSaving ? 'Subiendo copia literal...' : 'Enviar información' }}
    </button>
  </div>
</form>

